import { fetcher } from '../utils'

export default async (id: number): Promise<void> => fetcher(`/api/tag/delete/${id}`, 'DELETE', undefined)
